import { render, staticRenderFns } from "./Setup.vue?vue&type=template&id=abf2dfc6&scoped=true&"
import script from "./Setup.vue?vue&type=script&lang=js&"
export * from "./Setup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abf2dfc6",
  null
  
)

export default component.exports